module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("\n<div id=\"diff_")
    ; __append(escapeFn( diffData.id ))
    ; __append("\" class=\"card swh-file-diff-panel\">\n  <div class=\"card-header bg-gray-light border-bottom-0\">\n    <a data-toggle=\"collapse\" href=\"#diff_")
    ; __append(escapeFn( diffData.id ))
    ; __append("_content\">\n      <div class=\"float-left swh-title-color\">\n        <strong>")
    ; __append(escapeFn( diffPanelTitle ))
    ; __append("</strong>\n      </div>\n    </a>\n    <div class=\"ml-auto float-right\">\n      <div class=\"btn-group btn-group-toggle diff-styles\" data-toggle=\"buttons\" style=\"visibility: hidden;\">\n        <label class=\"btn btn-default btn-sm form-check-label active unified-diff-button\" onclick=\"swh.revision.showUnifiedDiff('")
    ; __append(escapeFn( diffData.id ))
    ; __append("')\">\n          <input type=\"radio\" name=\"diffs-switch\" id=\"unified\" autocomplete=\"off\" checked=\"checked\"> Unified\n        </label>\n        <label class=\"btn btn-default btn-sm form-check-label split-diff-button\" onclick=\"swh.revision.showSplitDiff('")
    ; __append(escapeFn( diffData.id ))
    ; __append("')\">\n          <input type=\"radio\" name=\"diffs-switch\" id=\"side-by-side\" autocomplete=\"off\"> Side-by-side\n        </label>\n      </div>\n      <a href=\"")
    ; __append(escapeFn( diffData.content_url ))
    ; __append("\" class=\"btn btn-default btn-sm\" role=\"button\">View file</a>\n    </div>\n    <div class=\"clearfix\"></div>\n  </div>\n  <div id=\"diff_")
    ; __append(escapeFn( diffData.id ))
    ; __append("_content\" class=\"collapse show\">\n    <div class=\"swh-diff-loading text-center\" id=\"")
    ; __append(escapeFn( diffData.id ))
    ; __append("-loading\" style=\"visibility: hidden;\">\n      <img src=\"")
    ; __append(escapeFn( swhSpinnerSrc ))
    ; __append("\">\n      <p>Loading diff ...</p>\n    </div>\n    <div class=\"highlightjs swh-content\" style=\"display: none;\" id=\"")
    ; __append(escapeFn( diffData.id ))
    ; __append("-highlightjs\">\n      <div id=\"")
    ; __append(escapeFn( diffData.id ))
    ; __append("-unified-diff\">\n        <pre><code class=\"")
    ; __append(escapeFn( diffData.id ))
    ; __append("\" id=\"")
    ; __append(escapeFn( diffData.id ))
    ; __append("\"></code></pre>\n      </div>\n      <div style=\"width: 100%; display: none;\" id=\"")
    ; __append(escapeFn( diffData.id ))
    ; __append("-split-diff\">\n        <pre class=\"float-left\" style=\"width: 50%;\"><code class=\"")
    ; __append(escapeFn( diffData.id ))
    ; __append("\" id=\"")
    ; __append(escapeFn( diffData.id ))
    ; __append("-from\"></code></pre>\n        <pre style=\"width: 50%;\"><code class=\"")
    ; __append(escapeFn( diffData.id ))
    ; __append("\" id=\"")
    ; __append(escapeFn( diffData.id ))
    ; __append("-to\"></code></pre>\n      </div>\n    </div>\n  </div>\n</div>")
  }
  return __output;

}